var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewOnBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4329 10.524C20.7879 7.61395 16.4009 4.53795 12.0009 4.59995C7.60088 4.53695 3.21388 7.61495 0.568877 10.524C0.206307 10.9293 0.00585937 11.4541 0.00585938 11.998C0.00585937 12.5418 0.206307 13.0666 0.568877 13.472C3.18288 16.351 7.50788 19.4 11.8399 19.4H12.1479C16.4949 19.4 20.8189 16.351 23.4359 13.471C23.798 13.0654 23.9978 12.5406 23.9973 11.9969C23.9967 11.4532 23.7958 10.9288 23.4329 10.524V10.524ZM7.40088 12C7.40088 11.0902 7.67066 10.2008 8.17612 9.44433C8.68157 8.68786 9.39999 8.09827 10.2405 7.7501C11.0811 7.40194 12.006 7.31085 12.8983 7.48834C13.7906 7.66583 14.6102 8.10394 15.2536 8.74726C15.8969 9.39058 16.335 10.2102 16.5125 11.1025C16.69 11.9948 16.5989 12.9198 16.2507 13.7603C15.9026 14.6008 15.313 15.3193 14.5565 15.8247C13.8 16.3302 12.9107 16.6 12.0009 16.6C10.7809 16.6 9.61085 16.1153 8.74819 15.2526C7.88552 14.39 7.40088 13.2199 7.40088 12Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOnBold);
export default __webpack_public_path__ + "static/media/view-on-bold.c2de52f0aaf381ba7853d14558148fdf.svg";
export { ForwardRef as ReactComponent };